import {useMemo, lazy, Suspense, LazyExoticComponent} from 'react'
import Loading from '@/components/shared/Loading'
import {setLayout, useAppDispatch, useAppSelector} from '@/store'
import {
    LAYOUT_TYPE_CLASSIC,
    LAYOUT_TYPE_MODERN,
    LAYOUT_TYPE_SIMPLE,
    LAYOUT_TYPE_STACKED_SIDE,
    LAYOUT_TYPE_NEW,
    LAYOUT_TYPE_DECKED,
    LAYOUT_TYPE_BLANK,
} from '@/constants/theme.constant'
import useDirection from '@/utils/hooks/useDirection'
import useLocale from '@/utils/hooks/useLocale'
import {LayoutType} from "@/@types/theme";

const layouts = {
    [LAYOUT_TYPE_CLASSIC]: lazy(() => import('./ClassicLayout')),
    [LAYOUT_TYPE_MODERN]: lazy(() => import('./ModernLayout')),
    [LAYOUT_TYPE_STACKED_SIDE]: lazy(() => import('./StackedSideLayout')),
    [LAYOUT_TYPE_SIMPLE]: lazy(() => import('./SimpleLayout')),
    [LAYOUT_TYPE_NEW]: lazy(() => import('./NewLayout')),
    [LAYOUT_TYPE_DECKED]: lazy(() => import('./DeckedLayout')),
    [LAYOUT_TYPE_BLANK]: lazy(() => import('./BlankLayout')),
}

const Layout = () => {
    const dispatch = useAppDispatch()
    // const layoutType = useAppSelector((state) => state.theme.layout.type)
    const signedIn = useAppSelector((state) => state.auth.session.signedIn)
    const layoutType = useAppSelector(state => state.auth.role?.layoutType || 2)

    useDirection()

    useLocale()

    const AppLayout = useMemo(() => {
        if (signedIn) {
            return layouts[layoutType]
        }

        return lazy(() => import('./AuthLayout'))
    }, [layoutType, signedIn])

    return (
        <Suspense
            fallback={
                <div className="flex flex-auto flex-col h-[100vh]">
                    <Loading loading={true} />
                </div>
            }
        >
            <AppLayout />
        </Suspense>
    )
}

export default Layout
